import React from 'react';

/**
 * 抽屜開啟動畫期間不讓遮罩關閉。
 *
 * 手機上「點圖表 → 抽屜出現 → 瞬間消失」的成因：
 *
 * antd 的 Drawer 一開啟就把遮罩鋪滿整個視窗，但內容包裝還在畫面外往內滑。
 * 所以在滑入動畫跑完之前，螢幕上任何一點打到的都是遮罩 —— 而 maskClosable
 * 預設是 true，打到就關。
 *
 * 實測 (390px、真實觸控 context、訂房曲線抽屜)：
 *
 *   第二次點擊延遲 0 / 50 / 100 / 150 / 200 / 300ms → 命中 .ant-drawer-mask → 抽屜被關掉
 *   第二次點擊延遲 450ms                            → 命中抽屜內容 CANVAS  → 抽屜還開著
 *
 * 行動瀏覽器在觸控之後會補送一組相容性滑鼠事件，那個遲到的點擊正好落在這個
 * 窗口裡；桌機的滑鼠只產生一次 click，所以看不到這個問題。
 *
 * 修法刻意不去追究「第二個點擊從哪來」——「抽屜都還沒滑出來就能被點掉」本身
 * 就是缺陷：那個點擊不可能是使用者「刻意點外面關閉」的意圖。擋在這一層，
 * 不論第二個點擊來自相容性事件、雙擊、還是別的來源，都攔得住。
 */

/**
 * 保護窗口。必須大於實測會關掉抽屜的 300ms，並留一點餘裕給較慢的裝置；
 * 又不能長到讓使用者覺得「點外面沒反應」。
 */
export const MASK_GUARD_MS = 350;

export default function useMaskCloseGuard(open) {
    const [closable, setClosable] = React.useState(false);

    React.useEffect(() => {
        if (!open) {
            // 關閉時就重設，下一次開啟才會重新進入保護窗口
            setClosable(false);
            return undefined;
        }

        setClosable(false);
        const timer = setTimeout(() => setClosable(true), MASK_GUARD_MS);

        return () => clearTimeout(timer);
    }, [open]);

    return closable;
}
